// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3isNV","content":"styles_content__37mI9","selectAll":"styles_selectAll__1W92u"};